function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.753 31.0298H134.709V57.3181H164.753V31.0298Z",
  fill: "#2A7771"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.636 0.985962H170.825C171.624 0.985962 172.263 1.65959 172.263 2.50162V37.025C172.263 37.8671 171.624 38.5407 170.825 38.5407H128.636C127.836 38.5407 127.197 37.8671 127.197 37.025V2.50162C127.197 1.65959 127.836 0.985962 128.636 0.985962Z",
  fill: "#3CA19D"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.0653 57.301L37.0664 70.3036L54.9914 88.2235L67.9902 75.2209L50.0653 57.301Z",
  fill: "#2A7771"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6584 58.2564L38.0294 38.8854C38.489 38.4258 39.2442 38.4258 39.7366 38.8854L60.3552 59.504C60.8148 59.9636 60.8148 60.7188 60.3552 61.1784L40.9843 80.5494C40.5246 81.009 39.7695 81.009 39.277 80.5494L18.6584 59.9308C18.1659 59.504 18.1659 58.7488 18.6584 58.2564Z",
  fill: "#3CA19D"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M250.274 57.3106L232.352 75.233L245.352 88.2337L263.275 70.3113L250.274 57.3106Z",
  fill: "#2A7771"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M262.335 38.8854L281.706 58.2563C282.165 58.716 282.165 59.4711 281.706 59.9636L261.087 80.5822C260.627 81.0418 259.872 81.0418 259.38 80.5822L240.009 61.2112C239.549 60.7516 239.549 59.9964 240.009 59.504L260.627 38.8854C261.12 38.4257 261.875 38.4257 262.335 38.8854Z",
  fill: "#3CA19D"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.093 46.4202C230.91 46.4202 297.273 112.784 297.273 194.601C297.273 276.418 230.957 342.782 149.093 342.782C67.2758 342.782 0.912109 276.465 0.912109 194.601C0.912109 112.784 67.2758 46.4202 149.093 46.4202Z",
  fill: "#2A7771"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M149.039 331.262C225.222 331.262 286.981 269.503 286.981 193.32C286.981 117.137 225.222 55.3784 149.039 55.3784C72.8562 55.3784 11.0977 117.137 11.0977 193.32C11.0977 269.503 72.8562 331.262 149.039 331.262Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.4831 113.533L40.9414 119.784L53.213 128.7L57.7547 122.449L45.4831 113.533Z",
  fill: "#B9D0FE"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.6719 124.787L33.8086 131.478L46.9448 139.062L50.8081 132.371L37.6719 124.787Z",
  fill: "#B9D0FE"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.0647 136.809L27.9199 143.867L41.7752 150.041L44.9199 142.983L31.0647 136.809Z",
  fill: "#B9D0FE"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.8297 149.452L23.4375 156.799L37.8616 161.496L40.2537 154.148L25.8297 149.452Z",
  fill: "#B9D0FE"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.8848 162.603L20.2754 170.16L35.112 173.32L36.7215 165.763L21.8848 162.603Z",
  fill: "#B9D0FE"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.35 176.049L18.5449 183.734L33.6318 185.314L34.437 177.629L19.35 176.049Z",
  fill: "#B9D0FE"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.3837 189.714H18.2148V197.44H33.3837V189.714Z",
  fill: "#B9D0FE"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.6084 201.848L18.5215 203.429L19.3266 211.113L34.4135 209.533L33.6084 201.848Z",
  fill: "#B9D0FE"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.1238 213.866L20.2871 217.026L21.8966 224.583L36.7332 221.424L35.1238 213.866Z",
  fill: "#B9D0FE"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.844 225.676L23.4199 230.372L25.8121 237.719L40.2361 233.023L37.844 225.676Z",
  fill: "#B9D0FE"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.8201 237.101L27.9648 243.275L31.1096 250.333L44.9648 244.159L41.8201 237.101Z",
  fill: "#B9D0FE"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.9461 248.112L33.8145 255.706L37.6824 262.394L50.8141 254.801L46.9461 248.112Z",
  fill: "#B9D0FE"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.2134 258.456L40.9434 267.374L45.4858 273.624L57.7559 264.706L53.2134 258.456Z",
  fill: "#B9D0FE"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.505 268.13L49.2285 278.277L54.3969 284.021L65.6734 273.874L60.505 268.13Z",
  fill: "#B9D0FE"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.7773 277.019L58.6309 288.295L64.3748 293.463L74.5213 282.187L68.7773 277.019Z",
  fill: "#B9D0FE"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M77.9403 284.927L69.0332 297.206L75.2879 301.743L84.195 289.464L77.9403 284.927Z",
  fill: "#B9D0FE"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.8783 291.887L80.2969 305.025L86.9889 308.887L94.5703 295.749L87.8783 291.887Z",
  fill: "#B9D0FE"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M98.4563 297.707L92.3008 311.57L99.3621 314.706L105.518 300.843L98.4563 297.707Z",
  fill: "#B9D0FE"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.677 302.46L104.99 316.887L112.339 319.275L117.026 304.848L109.677 302.46Z",
  fill: "#B9D0FE"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M121.244 305.98L118.086 320.817L125.643 322.425L128.802 307.589L121.244 305.98Z",
  fill: "#B9D0FE"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.133 308.261L131.564 323.348L139.249 324.147L140.818 309.06L133.133 308.261Z",
  fill: "#B9D0FE"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152.934 309.311H145.207V324.479H152.934V309.311Z",
  fill: "#B9D0FE"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M166.633 323.342L158.906 324.148L157.342 309.074L165.021 308.268L166.633 323.342Z",
  fill: "#B9D0FE"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M176.93 305.967L169.373 307.576L172.531 322.412L180.089 320.804L176.93 305.967Z",
  fill: "#B9D0FE"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M188.527 302.424L181.178 304.811L185.865 319.238L193.214 316.851L188.527 302.424Z",
  fill: "#B9D0FE"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M199.662 297.735L192.6 300.869L198.752 314.734L205.814 311.6L199.662 297.735Z",
  fill: "#B9D0FE"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M210.28 291.844L203.588 295.705L211.169 308.843L217.861 304.981L210.28 291.844Z",
  fill: "#B9D0FE"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M220.221 284.922L213.969 289.462L222.88 301.736L229.133 297.197L220.221 284.922Z",
  fill: "#B9D0FE"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M229.393 276.973L223.648 282.141L233.793 293.419L239.538 288.251L229.393 276.973Z",
  fill: "#B9D0FE"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M237.659 268.162L232.49 273.905L243.765 284.053L248.934 278.309L237.659 268.162Z",
  fill: "#B9D0FE"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M244.978 258.458L240.432 264.706L252.697 273.631L257.244 267.383L244.978 258.458Z",
  fill: "#B9D0FE"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M251.228 248.116L247.363 254.807L260.498 262.394L264.363 255.704L251.228 248.116Z",
  fill: "#B9D0FE"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.354 237.1L253.209 244.157L267.064 250.331L270.209 243.274L256.354 237.1Z",
  fill: "#B9D0FE"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M260.333 225.677L257.945 233.025L272.372 237.713L274.76 230.364L260.333 225.677Z",
  fill: "#B9D0FE"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M263.06 213.864L261.457 221.422L276.295 224.57L277.898 217.012L263.06 213.864Z",
  fill: "#B9D0FE"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M264.558 201.838L263.753 209.523L278.84 211.103L279.645 203.418L264.558 201.838Z",
  fill: "#B9D0FE"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M279.973 189.714H264.804V197.44H279.973V189.714Z",
  fill: "#B9D0FE"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M278.878 176.056L263.791 177.636L264.596 185.321L279.683 183.74L278.878 176.056Z",
  fill: "#B9D0FE"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M276.289 162.578L261.451 165.726L263.054 173.284L277.893 170.136L276.289 162.578Z",
  fill: "#B9D0FE"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M272.396 149.437L257.969 154.124L260.356 161.473L274.783 156.785L272.396 149.437Z",
  fill: "#B9D0FE"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M267.066 136.824L253.211 142.998L256.356 150.055L270.211 143.882L267.066 136.824Z",
  fill: "#B9D0FE"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M260.458 124.785L247.318 132.363L251.179 139.056L264.318 131.478L260.458 124.785Z",
  fill: "#B9D0FE"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M252.672 113.514L240.406 122.438L244.952 128.686L257.217 119.762L252.672 113.514Z",
  fill: "#B9D0FE"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152.932 62.6748H145.205V77.8436H152.932V62.6748Z",
  fill: "#B9D0FE"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M139.225 63.0237L131.541 63.8334L133.131 78.9188L140.815 78.1091L139.225 63.0237Z",
  fill: "#B9D0FE"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M125.671 64.7305L118.113 66.3392L121.271 81.1758L128.829 79.5672L125.671 64.7305Z",
  fill: "#B9D0FE"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.343 67.9117L104.994 70.2992L109.681 84.7263L117.03 82.3388L112.343 67.9117Z",
  fill: "#B9D0FE"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.3505 72.4328L92.293 75.5775L98.4667 89.4328L105.524 86.288L99.3505 72.4328Z",
  fill: "#B9D0FE"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M86.9862 78.3092L80.2988 82.1794L87.8969 95.3081L94.5843 91.4378L86.9862 78.3092Z",
  fill: "#B9D0FE"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.2559 85.4304L69.0059 89.9737L77.9251 102.244L84.1752 97.7005L75.2559 85.4304Z",
  fill: "#B9D0FE"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.4041 93.7422L58.6602 98.9105L68.8066 110.187L74.5506 105.019L64.4041 93.7422Z",
  fill: "#B9D0FE"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54.3937 103.145L49.2207 108.885L60.4881 119.04L65.6611 113.301L54.3937 103.145Z",
  fill: "#B9D0FE"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M243.739 103.097L232.473 113.254L237.646 118.993L248.912 108.835L243.739 103.097Z",
  fill: "#B9D0FE"
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M233.784 93.7347L223.639 105.013L229.383 110.18L239.528 98.9023L233.784 93.7347Z",
  fill: "#B9D0FE"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M222.908 85.4383L213.984 97.7038L220.232 102.249L229.156 89.9839L222.908 85.4383Z",
  fill: "#B9D0FE"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M211.153 78.3034L203.555 91.432L210.242 95.3022L217.84 82.1736L211.153 78.3034Z",
  fill: "#B9D0FE"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198.803 72.4464L192.633 86.3032L199.691 89.4464L205.862 75.5896L198.803 72.4464Z",
  fill: "#B9D0FE"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  d: "M185.861 67.8951L181.174 82.3221L188.523 84.7097L193.21 70.2826L185.861 67.8951Z",
  fill: "#B9D0FE"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.543 64.7497L169.385 79.5863L176.942 81.195L180.1 66.3584L172.543 64.7497Z",
  fill: "#B9D0FE"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158.926 63.0028L157.336 78.0882L165.02 78.898L166.61 63.8126L158.926 63.0028Z",
  fill: "#B9D0FE"
});

var SvgGameResultTimer = function SvgGameResultTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 298,
    height: 343,
    viewBox: "0 0 298 343",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGameResultTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/game-result-timer.8a0f8d90.svg";
export { ForwardRef as ReactComponent };